export default "__VITE_ASSET__DgA9kpL7__"